// extracted by mini-css-extract-plugin
module.exports = {"win-card-box":"gk","winCardBox":"gk","win-card-btn-detail":"gl","winCardBtnDetail":"gl","win-card-dec":"gm","winCardDec":"gm","win-card-name":"gn","winCardName":"gn"};